export const quickbooksRealmsConstants = {
  QUICKBOOKS_REALMS_LIST_LOADING: 'QUICKBOOKS_REALMS_LIST_LOADING',
  QUICKBOOKS_REALMS_LIST_SUCCESS: 'QUICKBOOKS_REALMS_LIST_SUCCESS',
  QUICKBOOKS_REALMS_LIST_FAILURE: 'QUICKBOOKS_REALMS_LIST_FAILURE',

  QUICKBOOKS_REALMS_DELETE_LOADING: 'QUICKBOOKS_REALMS_DELETE_LOADING',
  QUICKBOOKS_REALMS_DELETE_SUCCESS: 'QUICKBOOKS_REALMS_DELETE_SUCCESS',
  QUICKBOOKS_REALMS_DELETE_FAILURE: 'QUICKBOOKS_REALMS_DELETE_FAILURE'
};
